/** @format */

import {
	BottomPaginationComponent,
	ColorBreakoutComponent,
	CompareBarComponent,
	ExposedFiltersComponent,
	FilterChipsComponent,
	FilterComponent,
	NoFilteredResultsComponent,
	NotFoundComponent,
	PinnedContentComponent,
	PlpFeatureSpotComponent,
	ProductListHeaderComponent,
	ShippingOptionsComponent,
	SortComponent,
	TopPaginationComponent
} from '@plp/components';
import {
	CarouselButtonComponent,
	LoadingOverlayModule,
	ProTipsComponent,
	SnackbarComponent
} from '@shared/components';
import {
	HmfButtonComponent,
	HmfCardComponent,
	HmfSidePanelComponent,
	HmfStarRatingsComponent
} from '@dsg-tech/homefield-angular';
import {
	HomefieldGlobalChipsModule,
	HomefieldHeroBannerModule,
	HomefieldPriceModule,
	HomefieldProductImageModule,
	HomefieldStrikethroughPriceModule,
	HomefieldTextLinkModule
} from '@homefield';

import { BreakPointMinWidthValues } from '@shared/data-access/enums';
import { CommonModule } from '@angular/common';
import { DynamicTemplateLoader } from '@shared/data-access/services';
// Had to import this way so that '@shared/favorites/components' doesn't eagerly load the ProductRecommendationsComponent;
import { FavoritesIconComponent } from '@shared/favorites/components';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { IncludesPipe } from '@plp/utils';
import { MathFloorPipe } from '@shared/utils/pipes';
import { ProductCardComponent, SkeletonProductCardComponent } from '@shared/totf/components';
import { HomrTemplateComponent } from '@plp/homr/components';

export const IMPORTS = [
	BottomPaginationComponent,
	ColorBreakoutComponent,
	CommonModule,
	CompareBarComponent,
	FavoritesIconComponent,
	FilterComponent,
	FilterChipsComponent,
	HmfButtonComponent,
	HmfCardComponent,
	HmfSidePanelComponent,
	HmfStarRatingsComponent,
	HomefieldGlobalChipsModule,
	HomefieldHeroBannerModule,
	HomefieldIconLibraryModule,
	HomefieldPriceModule,
	HomefieldProductImageModule,
	HomefieldStrikethroughPriceModule,
	HomefieldTextLinkModule,
	IncludesPipe,
	LoadingOverlayModule,
	MathFloorPipe,
	NoFilteredResultsComponent,
	NotFoundComponent,
	PinnedContentComponent,
	PlpFeatureSpotComponent,
	ProTipsComponent,
	ProductCardComponent,
	ProductListHeaderComponent,
	ShippingOptionsComponent,
	SkeletonProductCardComponent,
	SnackbarComponent,
	SortComponent,
	TopPaginationComponent,
	ExposedFiltersComponent,
	CarouselButtonComponent,
	HomrTemplateComponent
];

export const DEVICE_BREAKPOINT_MEDIA_QUERIES = {
	EXTRA_EXTRA_SMALL: `(max-width: ${BreakPointMinWidthValues.EXTRASMALL - 1}px)`,
	EXTRA_SMALL: `(min-width: ${BreakPointMinWidthValues.EXTRASMALL}px) and (max-width: ${BreakPointMinWidthValues.SMALL - 1}px)`,
	SMALL: `(min-width: ${BreakPointMinWidthValues.SMALL}px) and (max-width: ${BreakPointMinWidthValues.MEDIUM - 1}px)`,
	MEDIUM: `(min-width: ${BreakPointMinWidthValues.MEDIUM}px) and (max-width: ${BreakPointMinWidthValues.LARGE - 1}px)`,
	LARGE: `(min-width: ${BreakPointMinWidthValues.LARGE}px) and (max-width: ${BreakPointMinWidthValues.EXTRALARGE - 1}px)`,
	EXTRA_LARGE: `(min-width: ${BreakPointMinWidthValues.EXTRALARGE}px) and (max-width: ${BreakPointMinWidthValues.EXTRAEXTRALARGE - 1}px)`,
	EXTRA_EXTRA_LARGE: `(min-width: ${BreakPointMinWidthValues.EXTRAEXTRALARGE}px)`
};

export const PROVIDERS = [DynamicTemplateLoader];
